import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { AbstractView } from "@lib/titan2/dist/game/view/AbstractView";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { DestroyUtil } from "@lib/titan2/dist/util/view/DestroyUtil";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { ReelAnim } from "../properties/AbstractReelProperties";
/**
 * ReelSymbol.ts
 */
export class ReelSymbol extends AbstractView {
    constructor(landscapeProperties, portraitProperties, reelProperties) {
        super();
        this.landscapeProperties = landscapeProperties;
        this.portraitProperties = portraitProperties;
        this.spine = TitanSpine.createSpine(this, landscapeProperties, portraitProperties);
        this.reelProperties = reelProperties;
    }
    reset() {
        DestroyUtil.destroy(this.spine);
        this.spine = TitanSpine.createSpine(this, this.landscapeProperties, this.portraitProperties);
    }
    getSpine() {
        return this.spine;
    }
    play() {
        //nop
    }
    gotoAndStop() {
        SpineUtil.stop(this.spine);
    }
    strikeJoker() {
        Logger.verbose("strikeJoker");
        SpineUtil.play(this.spine, this.reelProperties.wildAnims[ReelAnim.LAND], this.handleJokerLanding.bind(this));
    }
    strikeSuperJoker() {
        Logger.verbose("strikeSuperJoker");
        SpineUtil.play(this.spine, this.reelProperties.superWildAnims[ReelAnim.LAND], this.handleSuperJokerLanding.bind(this));
    }
    strikeFreeSpin() {
        Logger.verbose("strikeFreeSpin");
        SpineUtil.playLoop(this.spine, this.reelProperties.freeSpinAnims[ReelAnim.LOOP]);
    }
    strikeNumber() {
        Logger.verbose("strikeNumber");
        SpineUtil.play(this.spine, this.reelProperties.numberAnims[ReelAnim.LAND]);
    }
    strikeCollectible() {
        //SpineUtil.play(this.spine, this.reelProperties.collectibleAnims[ReelAnim.LAND], this.handleCollectibleLanding.bind(this))
    }
    stopJoker() {
        Logger.verbose("stopJoker");
        SpineUtil.play(this.spine, this.reelProperties.wildAnims[ReelAnim.STATIC]);
    }
    stopSuperJoker() {
        Logger.verbose("stopSuperJoker");
        SpineUtil.play(this.spine, this.reelProperties.superWildAnims[ReelAnim.STATIC]);
    }
    stopFreeSpin() {
        Logger.verbose("stopFreeSpin");
        SpineUtil.play(this.spine, this.reelProperties.freeSpinAnims[ReelAnim.STATIC]);
    }
    stopCollectible() {
        Logger.verbose("stopCollectible");
        SpineUtil.play(this.spine, this.reelProperties.collectibleAnims[ReelAnim.STATIC]);
    }
    handleJokerLanding() {
        Logger.verbose("stopJokerLanding");
        SpineUtil.playLoop(this.spine, this.reelProperties.wildAnims[ReelAnim.LOOP]);
    }
    strikeScatter() {
        Logger.verbose("strikeScatter");
        SpineUtil.play(this.spine, this.reelProperties.scatterAnims[ReelAnim.LAND], this.handleScatterLanding.bind(this));
    }
    handleScatterLanding() {
        Logger.verbose("strikeScatterLanding");
        SpineUtil.playLoop(this.spine, this.reelProperties.scatterAnims[ReelAnim.LOOP]);
    }
    handleSuperJokerLanding() {
        Logger.verbose("superJokerLanding");
        SpineUtil.playLoop(this.spine, this.reelProperties.superWildAnims[ReelAnim.LOOP]);
    }
    handleCollectibleLanding() {
        SpineUtil.play(this.spine, this.reelProperties.collectibleAnims[ReelAnim.STATIC]);
    }
}
//# sourceMappingURL=ReelSymbol.js.map